import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import * as S from './InitialContent.css';
const InitialContent = ({ description, customHeight, square = false, withoutShadow = false, }) => (_jsx(S.InitContent, Object.assign({ withoutshadow: withoutShadow.toString(), square: square, style: {
        minHeight: customHeight || '30vh',
    } }, { children: _jsx(Typography, Object.assign({ variant: "h5" }, { children: description })) })));
export default InitialContent;
